import React from "react";
import { Link, Text } from "@ds/react";
import * as S from "./ItemContent.style";
import { phoneToHref } from "utils/string";
import { useTheme } from "styled-components";
import { getQuery } from "utils/mediaQuery";
import devicesImg from "assets/images/devices.png";
import devicesImgWebp from "assets/images/devices.webp";

const ItemContent = () => {
  const theme = useTheme();
  return (
    <S.Container>
      <div>
        <S.Section>
          <S.FirstItem>
            <S.Divider orientation="vertical" />
            <S.Content>
              <S.Block>
                <S.Title variant="headline-05">Fale com a gente</S.Title>
              </S.Block>
              <S.Block>
                <Link
                  variant="primary-lg-01"
                  href={phoneToHref("0800 272 2021")}
                >
                  0800 272 2021
                </Link>
                <Text variant="caption-02">
                  Consultas ou serviços, de segunda a sexta, das 8h às 21h,
                  exceto em feriados nacionais.
                </Text>
              </S.Block>
            </S.Content>
          </S.FirstItem>
          <S.ItemImg>
            <S.DevicesImgs>
              <source
                srcSet={devicesImgWebp}
                media={getQuery(theme.breakpoint.md())}
                type="image/webp"
              />
              <source
                srcSet={devicesImg}
                media={getQuery(theme.breakpoint.md())}
                type="image/jpeg"
              />
              <img src={devicesImg} alt="Ilustração de dispositivos" />
            </S.DevicesImgs>
          </S.ItemImg>
        </S.Section>
      </div>
      <div>
        <S.Section>
          <S.Item>
            <S.Divider orientation="vertical" />
            <S.Content>
              <S.Block>
                <S.Title variant="headline-05">SAC 24h</S.Title>
              </S.Block>
              <S.Block>
                <Link
                  variant="primary-lg-01"
                  href={phoneToHref("0800 272 2000")}
                >
                  0800 272 2000
                </Link>
                <Text variant="caption-02">
                  Informações ou dúvidas dos produtos, reclamação, contestação,
                  suspensão ou cancelamentos.
                </Text>
              </S.Block>
            </S.Content>
          </S.Item>
          <S.Item>
            <S.Divider orientation="vertical" />
            <S.Content>
              <S.Block>
                <S.Title variant="headline-05">
                  Atendimento ao surdo 24h
                </S.Title>
              </S.Block>
              <S.Block>
                <Link
                  variant="primary-lg-01"
                  href={phoneToHref("0800 702 4260")}
                >
                  0800 702 4260
                </Link>
                <Text variant="caption-02">
                  Usando um aparelho adaptado com teclado alfanumérico.
                </Text>
              </S.Block>
            </S.Content>
          </S.Item>
          <S.Item>
            <S.Divider orientation="vertical" />
            <S.Content>
              <S.Block>
                <S.Title variant="headline-05">Ouvidoria</S.Title>
              </S.Block>
              <S.Block>
                <Link
                  variant="primary-lg-01"
                  href={phoneToHref("0800 272 2022")}
                >
                  0800 272 2022
                </Link>

                <Text variant="caption-02">
                  Reclamações não atendidas satisfatoriamente por outros canais,
                  sugestões ou elogios, de segunda a sexta, das 8h às 18h,
                  exceto em feriados nacionais.
                </Text>
              </S.Block>
            </S.Content>
          </S.Item>
        </S.Section>
      </div>
    </S.Container>
  );
};

export default ItemContent;
